export enum TEAM_STATUS {
    HIDDEN = 'hidden',
    DEFAULT = 'default'
}
